/* eslint-disable max-len */
import gqlRequest from 'graphql/generic';

type addChargeReturn = {
  createOrderLedgerEntry: {
    _id: string
  }
};

const mutation = `
mutation CreateOrderLedgerEntry(
	$id: ID!, 
	$amount: Float!, 
	$code: OrderLedgerCodes!, 
	$description: String!, 
	$kind: OrderLedgerKinds!, 
	$entryDate: String, 
	$letter:OrderLedgerCharges, 
	$number: Int, 
	$months: Int,
	$mortgageId: String
	) {
  createOrderLedgerEntry(
	_id: $id, 
	amount: $amount, 
	code: $code, 
	description: $description, 
	kind: $kind, 
	entry_date: $entryDate,
	letter: $letter,  
	number: $number, 
	months: $months,
	mortgage_id: $mortgageId
	) {
    _id
  }
}
`;
type manualchargeParams = {
  id: string,
  entryDate: string | null,
  description: string,
  code: string,
  amount: number,
  letter:string | null,
  kind: string,
  number?: number | null,
  months?:number | null
  mortgageId?:string | null
 }

export const addManualCharge = (params:manualchargeParams) => gqlRequest<addChargeReturn, manualchargeParams>(mutation, params);

export default {};
